import React, { Component } from 'react';
import './styles.css';

class OrangeButton extends Component {
	render() {
		const { disabled, onClick } = this.props;
		return (
			<div
				onClick={onClick}
				className={`results-document-layout-orange-button ${
					disabled ? 'disabled' : 'active'
				}`}
			>
				{
					!disabled
						? 'Send your report'
						: 'Report successfully sent'
				}
			</div>
		);
	}
}

export default OrangeButton;
